import { pageSizes, pickerOptions } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';
import HisAutocompleteSuggestions from '@/components/HisAutocompleteSuggestions/index.vue';
import FooterControl from '@/components/FooterControl.vue';
import { cityCode } from '@/utils/cityPicker/cityCode';
import { cloneDeep } from 'lodash';

export default {
  name: 'wait-fee',
  mixins: [pageSize],
  components: { HisAutocompleteSuggestions, FooterControl },
  data() {
    return {
      pageSizes,
      tableData: [],
      total: 0, // 总数据条数
      query: {
        hospitalName: '',
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
        hospitalType: -1, // 诊所类型 -1查全部  1：普通诊所 4：连锁诊所
        startTime: '',
        endTime: '',
      },
      statuss: [{
        value: -1,
        label: '全部',
      }, {
        value: 1,
        label: '普通诊所',
      }, {
        value: 4,
        label: '连锁诊所',
      }],
      pickerOptions,
      time: [],
      attr: [],
      optionss: cityCode,
    };
  },
  methods: {
    // 药品名称检索
    querySearch(str, cb) {
      this.$api.systemSet.hospitals({
        hospitalName: str,
        currentPage: 1,
        pageSize: 10,
      }).then((res) => {
        if (Array.isArray(res.order) && res.order.length > 0) {
          cb(res.order);
        } else {
          cb([]);
        }
      });
    },
    // 选择药品名称
    selectHandle(e) {
      this.query.hospitalName = e.hospitalName;
      this.getTableData(1);
    },
    searchHandel(e) {
      this.query.hospitalName = e;
      this.getTableData(1);
    },
    // 获取列表信息
    getTableData(type) {
      if (type === 1) this.query.currentPage = 1;
      this.query.startTime = this.time ? this.time[0] : '';
      this.query.endTime = this.time ? this.time[1] : '';
      const newAttr = cloneDeep(this.attr);
      const districtCodeList = newAttr.map(item => item.pop());
      this.$api.systemSet.chainHospital({
        ...this.query,
        districtCodeList,
      }).then((res) => {
        console.log(res);
        this.tableData = res.hospitalList || [];
        this.total = res.totalSize;
      });
    },
    // 跳转新建诊所
    gotoAddClinic() {
      this.$router.push({ name: 'newClinic' });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getTableData(1);
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.currentPage = val;
      this.getTableData();
    },
    gotoEditHospital(id) {
      this.$router.push({ path: '/system/newClinic', query: { state: 'edit', hospitalId: id } });
    },
    // 导出
    fileExport() {
      this.query.startTime = this.time ? this.time[0] : '';
      this.query.endTime = this.time ? this.time[1] : '';
      const newAttr = cloneDeep(this.attr);
      const districtCodeList = newAttr.map(item => item.pop());
      this.$api.systemSet.chainHospitalListExport({ ...this.query, districtCodeList });
    },
  },
  mounted() {
    this.getTableData();
  },
};
